// @flow
import * as React from 'react'

type Props = {
  capabilitiesToTestFor: [[string, (isAble: boolean) => void]]
}

/**
 * Simple component that checks for interaction capabilities – i.e. does the
 * user use touch or hover over stuff?
 *
 * Based on
 * https://medium.com/@david.gilbertson/the-only-way-to-detect-touch-with-javascript-7791a3346685
 */
class InteractionCapabilities extends React.PureComponent<Props> {
  static defaultProps = {
    capabilitiesToTestFor: []
  }

  componentDidMount () {
    this.props.capabilitiesToTestFor.forEach(test => {
      this.setupTest(...test)
    })
  }

  render () {
    return null
  }

  /**
   * Set up the capability we want to test for. This attaches an event
   * listener to the window (meaning: EVERYTHING!). Upon the first
   * interaction of that kind (like: a touch, or a mouse over, which, it
   * being the window, should happen pretty fast), it will call the appropriate
   * @param eventToTestFor
   * @param actionHandler
   */
  setupTest (eventToTestFor: string, actionHandler: (isAble: boolean) => void) {
    window.addEventListener(
      eventToTestFor,
      function onFirstInteraction () {
        // The require interaction has happened, call the handler function
        actionHandler(true)

        // Remove Event listener from window, it has done it's work
        window.removeEventListener(eventToTestFor, onFirstInteraction, false)
      },
      false
    )
  }
}

export default InteractionCapabilities
